import { tv } from 'tailwind-variants';

export interface ImageTextMediaDimensions {
  desktopWidth: number;
  desktopHeight: number;
  mobileWidth?: number;
  mobileHeight?: number;
}

export const imageTextMediaDimensions: ImageTextMediaDimensions = {
  desktopWidth: 544,
  desktopHeight: 544,
};

export const imageTextBlockVariants = tv({
  slots: {
    container: '',
    section: 'px-6 py-12 md:px-4xl md:py-3xl',
    layout: 'flex flex-col items-center gap-8 md:flex-row md:justify-between md:gap-3xl',
    textColumn: 'w-full min-w-0',
    content: 'space-y-4',
    iconWrapper: '',
    body: 'prose max-w-none',
    mediaColumn: 'max-sm:w-full',
    mediaFrame: 'flex h-81.75 w-full items-center justify-center md:mx-auto md:size-136',
  },
  variants: {
    imagePosition: {
      true: {
        textColumn: 'md:order-2',
        mediaColumn: 'md:order-1',
      },
      false: {
        textColumn: 'md:order-1',
        mediaColumn: 'md:order-2',
      },
    },
    iconPosition: {
      left: {},
      center: {},
      right: {},
    },
    isVideo: {
      true: { mediaFrame: 'bg-transparent' },
      false: { mediaFrame: 'bg-light-silver' },
    },
    hasLightText: {
      true: { body: '[&_*]:text-white!' },
      false: {},
    },
  },
  defaultVariants: {
    imagePosition: false,
    iconPosition: 'left',
    isVideo: false,
    hasLightText: false,
  },
});
